// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"225fe56a","81":"98a065d3","787":"21f74749"}[chunkId] + ".chunk.js";
};